import styled from "styled-components";

const AppStyled = styled.div`
    display: block;
    margin: 0;

    /* helpers */
    .flex--row {
        flex-direction: row;
    }
    .align--start {
        align-items: flex-start;
    }

    /* icons */
    .icon {
        background-position: left center;
        background-repeat: no-repeat;

        &--ruler {
            background-image: url(${props => props.theme.ruler});
        }
        &--scales {
            background-image: url(${props => props.theme.scales});
        }
        &--socks {
            background-image: url(${props => props.theme.socks});
        }
        &--paper {
            background-image: url(${props => props.theme.paper});
        }
        &--birthdaycard {
            background-image: url(${props => props.theme.birthdaycard});
        }
        &--postcard {
            background-image: url(${props => props.theme.postcard});
        }
        &--dvd {
            background-image: url(${props => props.theme.dvd});
        }
        &--newspaper {
            background-image: url(${props => props.theme.newspaper});
        }
        &--hat {
            background-image: url(${props => props.theme.hat});
        }
        &--phone {
            background-image: url(${props => props.theme.phone});
        }
        &--book {
            background-image: url(${props => props.theme.book});
        }
        &--trainers {
            background-image: url(${props => props.theme.trainers});
        }
        &--boots {
            background-image: url(${props => props.theme.boots});
        }
        &--coffeeMaker {
            background-image: url(${props => props.theme.coffeeMaker});
        }
        &--computer {
            background-image: url(${props => props.theme.computer});
        }
        &--standard {
            background-image: url(${props => props.theme.standardEnvelope});
        }
        &--large {
            background-image: url(${props => props.theme.largeEnvelope});
        }
        &--packet {
            background-image: url(${props => props.theme.packet});
        }
        &--parcel {
            background-image: url(${props => props.theme.parcel});
        }
    }
`;

export default AppStyled;
